const errors = {
  msg: {
    GENERIC: 'Ocorreu um erro inesperado.',
    CONNECTION_OFFLINE:
      'Erro ao estabelecer conexão com o servidor. Verifique sua conexão com a internet.',
    LOGIN_AUTH_INCORRECT: 'Usuário ou senha incorretos.',
    LOGIN_AUTH_REFUSED: 'Seu acesso ao curso está bloqueado no momento.',
    UNAUTHORIZED: 'Acesso negado. Usuário não autenticado.',
    FORBIDDEN: 'Acesso proíbido.',
    NOT_FOUND: 'Nada encontrado',
    BAD_REQUEST: 'Solicitação imprópria',
  },
  notification: {
    TOAST: 'TOAST',
    STRING: 'STRING',
    MODAL: 'MODAL',
  },
};

export default errors;

export const getErrorData = error => {
  const status = error.response ? error.response.status : '';
  switch (status) {
    case 401:
      if (error.response.data) {
        return { status, msg: error.response.data };
      }
      return { status, msg: error.response.statusText || '' };
    case 404:
      return { status, msg: '' };
    case 400:
      return { status, msg: error.response.data };
    default:
      return { status, msg: error };
  }
};

export const errorHandling = error => {
  const status = error.response ? error.response.status : 1;
  switch (status) {
    case 400:
      return { status, msg: errors.msg.BAD_REQUEST };
    case 401:
      return { status, msg: errors.msg.UNAUTHORIZED };
    case 403:
      return { status, msg: errors.msg.FORBIDDEN };
    case 404:
      return { status, msg: errors.msg.NOT_FOUND };
    default:
      return { status, msg: errors.msg.GENERIC };
  }
};
